"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _upload = _interopRequireDefault(require("@/components/upload"));
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TutorialEdit',
  components: {
    upload: _upload.default,
    Tinymce: _Tinymce.default
  },
  data: function data() {
    return {
      roles: [{
        title: '全部',
        level: 0
      }, {
        title: '总后台',
        level: 1
      }, {
        title: '城市合伙人',
        level: 2
      }, {
        title: '代理商',
        level: 3
      }, {
        title: '业务员',
        level: 4
      }, {
        title: '商家',
        level: 5
      }, {
        title: '用户',
        level: 6
      }, {
        title: '广告',
        level: 7
      }],
      agentInfo: {},
      siteInfo: {},
      form: {
        article_type: this.$route.query.type || 0,
        role_id: 0,
        is_all: 0
      },
      throw_agent_level: '',
      fileList: [],
      role: [],
      id: this.$route.query.id || ''
    };
  },
  mounted: function mounted() {
    this.siteInfo = window.siteInfo;
    this.agentInfo = window.agentInfo;
    this.roles = this.roles.splice(-(7 - this.agentInfo.agent_level));
    if (this.id > 0) {
      this.getInfo();
    } else {
      this.throw_agent_level = [];
    }
    this.getPower();
  },
  methods: {
    /**
       * 获取权限
       */
    getPower: function getPower() {
      var _this = this;
      this.$get('agentapi/add_agent').then(function (res) {
        _this.role = res.give_role_right;
      });
    },
    /**
       * 获取信息
       */
    getInfo: function getInfo() {
      var _this2 = this;
      this.$get('agentapi/article/detail', {
        id: this.id
      }).then(function (res) {
        _this2.form = res.info;
        _this2.fileList = [{
          url: res.info.img_url
        }];
        _this2.throw_agent_level = res.throw_agent_level;
      });
    },
    onSubmit: function onSubmit(formName) {
      var _this3 = this;
      var url = 'agentapi/article/add';
      var params = JSON.parse(JSON.stringify(this.form));
      if (params.is_all == 0) params.throw_agent_level = this.throw_agent_level;
      if (this.id > 0) url = 'agentapi/article/edit';
      this.$post(url, params).then(function (res) {
        _this3.$message({
          message: '提交成功',
          type: 'success'
        });
        history.go(-1);
      });
    },
    /**
       * 上传文件成功通知
       */
    fileOk: function fileOk(arr) {
      this.form.img_url = arr[0] || '';
    }
  }
};